import React from 'react';
import './assets/css/theme.scss';
import './assets/css/style.scss';
import EventGrid from './admin/EventGrid'

function App() {

  return (

    <div className="App">
      <EventGrid />
    </div>
  );
}

export default App;
